import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login'
import userHome from '../views/user/userHome'
import expertHome from "../views/expert/expertHome";
import stableIncome from "../views/user/dialog/stableIncome";
import dailyIncome from "../views/user/dialog/dailyIncome";
import inspectionTour from "../views/user/dialog/inspectionTour";
import purchaseAccount from "../views/user/dialog/purchaseAccount";
import salesAccount from "../views/user/dialog/salesAccount";
import dataAnalyse from "../views/user/analyse/dataAnalyse";
Vue.use(VueRouter)

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  routes : [
    { path: '/', redirect: '/Login' },
    { path: '/Login', component: Login },
    {
      path: '/userHome',component: userHome, redirect:'/stableIncome',
      children:[
          {path: '/stableIncome',component: stableIncome },
          {path: '/dailyIncome', component: dailyIncome},
          {path: '/inspectionTour', component: inspectionTour},
          {path: '/purchaseAccount', component: purchaseAccount},
          {path: '/salesAccount', component: salesAccount },

          {path: '/dataAnalyse', component: dataAnalyse},
          ]
    },
    {path: '/expertHome', component: expertHome}
  ]
})

// 挂载路由导航守卫
router.beforeEach((to,from,next) => {
  if (to.path === '/Login') return next()
 //获取token
  const constStr = window.sessionStorage.getItem('token')
  //如果token未登录,无法进入其他页面
  if (!constStr) return next('/Login')
  next()
})

export default router
